import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catExpanded, setCatExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setCatExpanded(false);
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="font-heading text-xl font-bold text-foreground-950 tracking-tight">
              SUPERBUY<span className="text-accent-500">.</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#categories"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              Categories
            </a>
            <a
              href="#guides"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              Guides
            </a>
            <a
              href="#faq"
              className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              FAQ
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-semibold bg-primary-500 text-white px-5 py-2.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {/*
        ==================== Mobile Menu Overlay ====================
      */}
      <div
        className={`fixed inset-0 z-40 bg-background-50 md:hidden transition-transform duration-300 ${
          mobileOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="pt-20 px-6 h-full overflow-y-auto pb-10">
          <nav className="flex flex-col gap-1">
            <a
              href="#categories"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-between px-4 py-3.5 rounded-xl text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer"
            >
              Categories
              <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-foreground-500"></i>
            </a>

            <button
              onClick={() => setCatExpanded(!catExpanded)}
              className="flex items-center justify-between px-4 py-3.5 rounded-xl bg-background-100 text-foreground-900 font-medium text-sm hover:bg-background-200/60 transition-colors cursor-pointer w-full"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
                Browse Product Categories
              </span>
              <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-foreground-500 transition-transform duration-200 ${catExpanded ? 'rotate-180' : ''}`}></i>
            </button>

            {catExpanded && (
              <div className="ml-2 border-l-2 border-background-200/60 pl-4 space-y-0.5 mt-1 mb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center justify-between px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    <span>{cat.name}</span>
                    <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center text-foreground-400"></i>
                  </a>
                ))}
              </div>
            )}

            <div className="h-px bg-background-200/60 my-3"></div>

            <a
              href="#guides"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
              Shopping Guides
            </a>

            <Link
              to="/article/superbuy-spreadsheet-complete-guide"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-foreground-700 text-sm hover:bg-background-100 transition-colors cursor-pointer ml-2 border-l-2 border-background-200/60 pl-6"
            >
              Complete Guide
            </Link>

            <Link
              to="/article/superbuy-spreadsheet-qc-guide"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-foreground-700 text-sm hover:bg-background-100 transition-colors cursor-pointer ml-2 border-l-2 border-background-200/60 pl-6"
            >
              QC Guide
            </Link>

            <Link
              to="/article/superbuy-spreadsheet-shipping-guide"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-foreground-700 text-sm hover:bg-background-100 transition-colors cursor-pointer ml-2 border-l-2 border-background-200/60 pl-6"
            >
              Shipping Guide
            </Link>

            <div className="h-px bg-background-200/60 my-3"></div>

            <a
              href="#faq"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-question-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
              FAQ
            </a>

            <div className="h-px bg-background-200/60 my-5"></div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Open Spreadsheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 px-6 py-3.5 bg-foreground-900 text-white font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-sm mt-2"
            >
              buy it now
              <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </nav>
        </div>
      </div>
    </>
  );
}